import { render, staticRenderFns } from "./newPriceList.vue?vue&type=template&id=0e7867ac&scoped=true"
import script from "./newPriceList.vue?vue&type=script&lang=js"
export * from "./newPriceList.vue?vue&type=script&lang=js"
import style0 from "./newPriceList.vue?vue&type=style&index=0&id=0e7867ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7867ac",
  null
  
)

export default component.exports